// All styles files start
import "animate.css";
import "./styles/App.css";
import "./styles/index.css";
import "./styles/responsive.css";
import "./styles/product.css";
import "./styles/override-bootstrap.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; //this is a JS file CDN

// swiperjs styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";

// All styles files end
import Home from "./components/Home/Home.jsx";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout.jsx";
import Products from "./components/Products/Products.jsx";
import ProductDetails from "./components/Products/ProductDetails.jsx";
import BlogPg from "./components/Blog/BlogPg.jsx";
import FaqPg from "./components/FAQ/FaqPg.jsx";
import ContactPg from "./components/Contact/ContactPg.jsx";
import AboutPg from "./components/About/AboutPg.jsx";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route>
          <Route path="/" element={<Layout children={<Home />} />} />
          <Route path="/home" element={<Layout children={<Home />} />} />
          <Route
            path="/products"
            element={<Layout children={<Products />} />}
          />
          <Route
            path="/product-details"
            element={<Layout children={<ProductDetails />} />}
          />
          <Route path="/blogs" element={<Layout children={<BlogPg />} />} />
          <Route path="/faq" element={<Layout children={<FaqPg />} />} />
          <Route
            path="/contact-us"
            element={<Layout children={<ContactPg />} />}
          />
          <Route path="/about-us" element={<Layout children={<AboutPg />} />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
